import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import LessonsPicker from 'views/modals/lessons_picker_modal'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import myLibraryActions from 'redux/actions/my_library_actions'

import { myLibrarySelectors } from 'redux/selectors'

class MyLibraryLessonsPickerModal extends Component {

	componentDidMount() {
		this.props.actions.init()
	}

	render() {
		return (
			<LessonsPicker
				modalName={this.props.modalName}
				folderName={this.props.folderName}
				placeholder={this.props.placeholder}
				showType={true}
				showPrice={false}
				closeModal={this.props.actions.cancel}
				searchLessons={this.props.actions.searchLessons}
				saveLessons={this.props.actions.saveLessons}
				cancel={this.props.actions.cancel} />
		)
	}
}

MyLibraryLessonsPickerModal.propTypes = {
	modalName: PropTypes.string,
	entityUID: PropTypes.string,
}

function mapStateToProps(state) {
	return myLibrarySelectors.myLibraryLessonsPickerModalViewSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		init: myLibraryActions.lessonsPickerInit,
		searchLessons: myLibraryActions.lessonsPickerSearchLessons,
		saveLessons: myLibraryActions.lessonsPickerSaveLessons,
		cancel: myLibraryActions.addMultipleLessonsToFolderCancel,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MyLibraryLessonsPickerModal)
